import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _7c3d6c68 = () => interopDefault(import('../pages/balance/index.vue' /* webpackChunkName: "pages/balance/index" */))
const _21439460 = () => interopDefault(import('../pages/basket/index.vue' /* webpackChunkName: "pages/basket/index" */))
const _13306547 = () => interopDefault(import('../pages/billing/index.vue' /* webpackChunkName: "pages/billing/index" */))
const _62d7a5b0 = () => interopDefault(import('../pages/collection/index.vue' /* webpackChunkName: "pages/collection/index" */))
const _7f9dd6be = () => interopDefault(import('../pages/delivery/index.vue' /* webpackChunkName: "pages/delivery/index" */))
const _22759142 = () => interopDefault(import('../pages/maintenance/index.vue' /* webpackChunkName: "pages/maintenance/index" */))
const _8ef2a4ce = () => interopDefault(import('../pages/notfound/index.vue' /* webpackChunkName: "pages/notfound/index" */))
const _422d2eaf = () => interopDefault(import('../pages/offline/index.vue' /* webpackChunkName: "pages/offline/index" */))
const _27a9ec5e = () => interopDefault(import('../pages/order-confirmation/index.vue' /* webpackChunkName: "pages/order-confirmation/index" */))
const _910279dc = () => interopDefault(import('../pages/payment/index.vue' /* webpackChunkName: "pages/payment/index" */))
const _ef5b7ec6 = () => interopDefault(import('../pages/queue/index.vue' /* webpackChunkName: "pages/queue/index" */))
const _94e6caa6 = () => interopDefault(import('../pages/register/index.vue' /* webpackChunkName: "pages/register/index" */))
const _b53e2a80 = () => interopDefault(import('../pages/shop/index.vue' /* webpackChunkName: "pages/shop/index" */))
const _057fca06 = () => interopDefault(import('../pages/soldout/index.vue' /* webpackChunkName: "pages/soldout/index" */))
const _09061cdb = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _2c6c67fd = () => interopDefault(import('../pages/champion-signup/_scheme/index.vue' /* webpackChunkName: "pages/champion-signup/_scheme/index" */))
const _67b1297a = () => interopDefault(import('../pages/claim/_slug/index.vue' /* webpackChunkName: "pages/claim/_slug/index" */))
const _1537286c = () => interopDefault(import('../pages/redeem-gift/_code/index.vue' /* webpackChunkName: "pages/redeem-gift/_code/index" */))
const _fc52854c = () => interopDefault(import('../pages/tickets/_order_id/_password/index.vue' /* webpackChunkName: "pages/tickets/_order_id/_password/index" */))
const _1f945de5 = () => interopDefault(import('../pages/shop' /* webpackChunkName: "" */))
const _f3c7fb66 = () => interopDefault(import('../pages/collection' /* webpackChunkName: "" */))
const _9a1d3480 = () => interopDefault(import('../pages' /* webpackChunkName: "" */))
const _2df1a5fa = () => interopDefault(import('../pages/order-confirmation' /* webpackChunkName: "" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/balance",
    component: _7c3d6c68,
    name: "balance"
  }, {
    path: "/basket",
    component: _21439460,
    name: "basket"
  }, {
    path: "/billing",
    component: _13306547,
    name: "billing"
  }, {
    path: "/collection",
    component: _62d7a5b0,
    name: "collection"
  }, {
    path: "/delivery",
    component: _7f9dd6be,
    name: "delivery"
  }, {
    path: "/maintenance",
    component: _22759142,
    name: "maintenance"
  }, {
    path: "/notfound",
    component: _8ef2a4ce,
    name: "notfound"
  }, {
    path: "/offline",
    component: _422d2eaf,
    name: "offline"
  }, {
    path: "/order-confirmation",
    component: _27a9ec5e,
    name: "order-confirmation"
  }, {
    path: "/payment",
    component: _910279dc,
    name: "payment"
  }, {
    path: "/queue",
    component: _ef5b7ec6,
    name: "queue"
  }, {
    path: "/register",
    component: _94e6caa6,
    name: "register"
  }, {
    path: "/shop",
    component: _b53e2a80,
    name: "shop"
  }, {
    path: "/soldout",
    component: _057fca06,
    name: "soldout"
  }, {
    path: "/",
    component: _09061cdb,
    name: "index"
  }, {
    path: "/champion-signup/:scheme",
    component: _2c6c67fd,
    name: "champion-signup-scheme"
  }, {
    path: "/claim/:slug",
    component: _67b1297a,
    name: "claim-slug"
  }, {
    path: "/redeem-gift/:code",
    component: _1537286c,
    name: "redeem-gift-code"
  }, {
    path: "/tickets/:order_id?/:password",
    component: _fc52854c,
    name: "tickets-order_id-password"
  }, {
    path: "/shop/:product_slug",
    components: {
      default: _1f945de5
    },
    name: "product"
  }, {
    path: "/collection/:collection_slug",
    components: {
      default: _f3c7fb66
    },
    name: "collection-page"
  }, {
    path: "/",
    components: {
      default: _9a1d3480
    },
    name: "home"
  }, {
    path: "/order-received",
    components: {
      default: _2df1a5fa
    },
    name: "confirmation"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
